"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.block = void 0;
const inline_1 = require("../inline");
const MdBlockParser_1 = require("./MdBlockParser");
const parsers_1 = require("./parsers");
exports.block = new MdBlockParser_1.MdBlockParser({ parsers: parsers_1.parsers, inline: inline_1.inline });
